import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-749c1f42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-rank-container f1 fv" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fh-c",
  style: {"height":"11.7%"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06" }, "客服会话量排行")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "fv",
  style: {"height":"88.3%"}
}
const _hoisted_4 = { class: "scrollbar rank-list f1 fv" }
const _hoisted_5 = { class: "item-order" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "item-progress f1" }
const _hoisted_8 = {
  key: 1,
  class: "fh-c-c",
  style: {"height":"88.3%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs12 color-04" }, "暂无会话数据", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.rankList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item fh-c",
                key: index
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(index + 1), 1),
                _createElementVNode("div", {
                  class: "item-name fs12 color-06",
                  title: item.serviceDeskName
                }, _toDisplayString(item.serviceDeskName), 9, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "item-progress-inner",
                    style: _normalizeStyle({ 'width': (item.count / _ctx.max * 100) + '%' })
                  }, _toDisplayString(item.count), 5)
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
  ]))
}